import { toast, Zoom } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

type ToastType = "success" | "error" | "info" | "warning";

export const showToast = (message: string, toastType: ToastType = "info") => {
    if (!message) return; 

    const autoClose =
        toastType === "success"
            ? 2500
            : toastType === "warning"
            ? 5000
            : toastType === "error"
            ? 7000
            : 2500;

    toast[toastType](message, {
        position: "top-right",
        autoClose,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Zoom,
    });
};